import React from 'react';
import { IUserLookup } from './interfaces';

export function formatUserValue(user?: IUserLookup) {
  if (!user) return '';

  return user.displayName || '';
}

function formatUserOption(user?: IUserLookup) {
  if (!user) return '';
  return (
    <div>
      <div>{`${user.isDisabled ? 'Inaktiv - ' : ''}${user.displayName}`}</div>
      <div>{user.searchSubText}</div>
    </div>
  );
}

export function renderUser(props: object, user?: IUserLookup) {
  return (
    <li {...props} key={user?.userIdentifier}>
      {formatUserOption(user)}
    </li>
  );
}
